import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { SFRTA_BridgeTestsAndInspectionReportSchema } from "./SFRTA_BridgeTestsAndInspectionReportSchema";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";

const masterKey = [
  { key: 'C', value: 'Test completed, no exceptions found, and condition left in compliance.' },
  { key: 'A', value: 'Adjustments made (identified in associated comments), test completed, and condition left in compliance.' },
  { key: 'R', value: 'Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.' },
  { key: 'B', value: 'Baseline data matches that recorded during the most recent Baseline test, so full test not required.' },
  { key: 'G', value: 'Governed by Special Instruction.' },
  { key: 'NT', value: 'The equipment was not tested in this inspection.' },
  { key: 'N', value: 'Test Not Applicable.' },
  { key: 'NI', value: 'No Inspection Required.' },
  { key: 'CO', value: 'Compliant' },
  { key: 'NC', value: 'Not compliant' },
  { key: 'P', value: 'Pass' },
  { key: 'F', value: 'Fail' },
]

const ReportView = (props) => {
  let { data } = props;

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Inspection Report - Bridge Tests & Inspections" {...props} fontSizeOverride={'35px'} />
      <span className="spacer"></span>
      <ReportFraInfoSectionContainer {...props} />
      <ReportFraConditionsMasterKey masterKey={masterKey} />
      <span className="spacer"></span>

      <table className="table-bordered" style={{ fontSize: '20px' }}>
        {SFRTA_BridgeTestsAndInspectionReportSchema.sections.map((section, i) => {
          return <ReportTableSectionRenderer key={i} section={section} rowsData={data.decodedData} />;
        })}
      </table>
    </div>
  );
};

const SFRTA_BridgeTestsAndInspectionReport = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ReportView
      data={{}}
    />
  }

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let reportGroups = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, [
    'sfrtaBridgeLockingForm',
  ]);
  let reportsWithDecodedFormData = ReportGroupingUtils.decodeTestsInReportGroups(reportGroups);

  return reportsWithDecodedFormData.map((report, i) => <ReportView
    key={i}
    {...props}
    data={report}
  />)
};

export default SFRTA_BridgeTestsAndInspectionReport;



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/BridgeTestsAndInspectionReport/index.jsx